import * as React from "react";
import { connect } from "react-redux";
import { latestJobsRequestData } from "../../redux/actions";
import { mapToMainBranch } from "../../helpers/nearestBranch";
import * as style from "./styles.module.scss";

interface ILocalJobs {
  responsibleTeam: string;
  branches: {
    name: string;
    lat: number;
    long: number;
    code: string;
  }[];
  latestJobs: {
    jobTitle: string;
    locationCity: string;
    locationRegion: string;
    id: string;
  }[];
  requestJobsData: (lat: number, long: number) => void;
}

const excludedBranchesCodes = ["NW", "EA", "SE"];

const LocalJobs = ({
  branches,
  requestJobsData,
  latestJobs,
  responsibleTeam,
}: ILocalJobs) => {
  const currentBranch = branches.filter(
    (branch) => branch.code === mapToMainBranch[responsibleTeam]
  )[0];

  React.useEffect(() => {
    if (currentBranch) {
      requestJobsData(currentBranch.lat, currentBranch.long);
    }
  }, []);

  const determineSalary = (job) => {
    if (job.salary === "Not Specified") {
      return `Not Specified`;
    }
    if (job.salaryType === "day") {
      if (job.salaryTo === job.salaryFrom) {
        return ` £${job.salaryTo} per day`;
      }
      return ` up to £${job.salaryTo} per day`;
    }
    if (job.salaryType === "hour") {
      if (job.salaryTo === job.salaryFrom) {
        return ` £${job.salaryTo} per hour`;
      }
      return ` up to £${job.salaryTo} per hour`;
    }
    if (job.salaryType === "annum" && job.salaryTo.length) {
      if (job.salaryTo === job.salaryFrom) {
        return ` £${job.salaryTo} per annum`;
      }
      return ` up to £${job.salaryTo} per annum`;
    }
    return `Not Specified`;
  };

  const getJobDescriptionLink = (job) => {
    const { id, jobTitle } = job;
    const slug = jobTitle.replace(/\s+/g, "-").toLowerCase();
    return `https://www.hrgo.co.uk/job/${slug}/${id}`;
  };

  const navigateToJobDescription = (job) => {
    window.open(getJobDescriptionLink(job), "_blank");
  };

  const showAllJobs = () => {
    window.open(
      `https://www.hrgo.co.uk/jobs?Keywords=&JobLocation=${currentBranch.name}&Latitude=${currentBranch.lat}&Longitude=${currentBranch.long}&submit=&JobType=All&JobType_AllTypes=true&JobType_Permanent=false&JobType_Temporary=false&JobType_Contract=false&JobSector=&SalaryPeriod=all`,
      "_blank"
    );
  };

  const branchIsExcluded = () =>
    !currentBranch || excludedBranchesCodes.includes(currentBranch.code);

  return !branchIsExcluded() ? (
    <div className="styles__branchDetails___Q5bd4">
      <div id="recentJobs" className={style.recentJobs}>
        <h2 id="recentJobsHeader" className={style.recentJobsHeader}>
          Latest jobs in {currentBranch && currentBranch.name}
        </h2>
        <div className={style.recentJobsRow}>
          {latestJobs &&
            latestJobs.map((job) => (
              <div
                onClick={() => navigateToJobDescription(job)}
                key={job.id}
                className={style.recentJobsCard}
              >
                <h5
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  className={style.recentJobsTitle}
                >
                  {job.jobTitle}
                </h5>
                <div className={style.recentJobsText}>
                  <i className="material-icons md-small"></i>
                  {job.locationRegion} - {job.locationCity}
                </div>

                <div className={style.recentJobsText}>
                  <img
                    className="material-icons md-small"
                    src="https://www.hrgo.co.uk/images/icons/coin.svg"
                    alt=""
                  />
                  {determineSalary(job)}
                </div>
              </div>
            ))}
        </div>
        <div className={style.recentJobsBtnContainer}>
          <button
            onClick={showAllJobs}
            style={{ width: "100%" }}
            className="btn btn-primary font-weight-bold  styles__profile__findjob_button___3AogV"
          >
            View all jobs in {currentBranch && currentBranch.name}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

const mapStateToProps = ({
  core: {
    app: { responsibleTeam },
    umbracoContent: { branches },
    latestJobs: { latestJobs },
  },
}) => ({
  branches,
  latestJobs,
  responsibleTeam,
});

const mapDispatchToProps = {
  requestJobsData: latestJobsRequestData,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(LocalJobs);
